const isIOSDevice = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

const copyToClipboard = async (text) => {
  if (!navigator.clipboard) return false;

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    console.error('Clipboard copy failed', e);
    return false;
  }
};

const openSMS = (url) => {
  window.location.href = url;
};

const sendSMS = async (inputNumbers, body) => {
  if (!inputNumbers) return;

  const numbers = (
    Array.isArray(inputNumbers) ? inputNumbers : [inputNumbers]
  ).filter(Boolean);

  if (!numbers.length) return;

  const isIOS = isIOSDevice();
  let smsUrl;

  if (isIOS) {
    smsUrl = `sms://open?addresses=${numbers.join(',')}`;
    if (body) smsUrl += `&body=${encodeURIComponent(body)}`;
  } else {
    smsUrl = `sms:${numbers.join(',')}`;
    if (body) smsUrl += `?body=${encodeURIComponent(body)}`;

    if (numbers.length > 1) {
      await copyToClipboard(numbers.slice(1).join(', '));
    }
  }

  openSMS(smsUrl);
};

export { sendSMS };
